import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { GatsbyImage } from 'gatsby-plugin-image';
import { FormattedMessage } from 'react-intl';
import { Container } from '../ui/common';
import Roll from '../ui/Roll';
import { Tabs, Tab, List, Block, Title, Text, Images, Wrap } from './styled';
import data from './data';

function Specifications({ images, type }) {
  const [active, setActive] = useState(0);
  const options = data[type];
  return (
    <section>
      <Container>
        <Roll
          title={<FormattedMessage id="specifications.title" />}
          startExpanded={false}
        >
          <Tabs>
            <Tab active={active === 0} onClick={() => setActive(0)}>
              <FormattedMessage id="specifications.tab1" />
            </Tab>
            <Tab active={active === 1} onClick={() => setActive(1)}>
              <FormattedMessage id="specifications.tab2" />
            </Tab>
          </Tabs>
          {active === 0 ? (
            <List>
              {Object.keys(options).map((key, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <Block key={index}>
                  <Title>
                    <FormattedMessage id={`specifications.${key}.title`} />
                  </Title>
                  <Text>
                    <FormattedMessage id={options[key]} />
                  </Text>
                </Block>
              ))}
            </List>
          ) : (
            <div>
              <Images>
                {images.map((image, i) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <Wrap key={i}>
                    <GatsbyImage image={image} alt="" />
                  </Wrap>
                ))}
              </Images>
            </div>
          )}
        </Roll>
      </Container>
    </section>
  );
}

export default Specifications;

Specifications.propTypes = {
  images: PropTypes.arrayOf(PropTypes.any),
  type: PropTypes.string.isRequired,
};

Specifications.defaultProps = {
  images: [],
};
